import { Charges, Refunds } from 'types/pwcOrder';

import formatNumber from 'utils/numbers';

import { KEYS } from '../../keys';

export enum TransactionType {
  CHARGE = 'charge',
  REFUND = 'refund',
}

interface FormatTransactionProps {
  transaction: Charges | Refunds;
  fiatCurrencyCode: string | null;
  type: TransactionType;
}

export interface FormattedTransaction {
  id: string;
  uuid: string;
  type: string;
  cryptoAmount: number;
  fiatAmount: string;
  lastUpdateAt: string;
  fiatCurrency: string | null;
  cryptoCurrency: string | null | undefined;
  expandable: string;
  status: Refunds['status'] | Charges['status'];
}

export const formatTransaction = ({ transaction, fiatCurrencyCode, type }: FormatTransactionProps): FormattedTransaction => {
  const isRefund = type === TransactionType.REFUND;

  if (isRefund) {
    const refund = transaction as Refunds;
    return {
      id: refund.uuid,
      uuid: refund.uuid,
      type: KEYS.REFUND_TYPE,
      cryptoAmount: Number(refund.netCryptoAmount),
      fiatAmount: formatNumber(Number(refund.fiatAmount)),
      lastUpdateAt: refund.createdAt,
      fiatCurrency: refund.fiatCurrencyCode ?? fiatCurrencyCode,
      cryptoCurrency: refund.cryptoCurrencyCode,
      expandable: 'expandable',
      status: refund.status,
    };
  }
  const charge = transaction as Charges;
  return {
    id: charge.uuid,
    uuid: charge.uuid,
    type: KEYS.CHARGE_TYPE,
    cryptoAmount: Number(charge.cryptoPayment.cryptoAmount),
    fiatAmount: formatNumber(Number(charge.cryptoExchange.fiatAmount)),
    lastUpdateAt: charge.updatedAt,
    fiatCurrency: fiatCurrencyCode,
    cryptoCurrency: charge.cryptoPayment.cryptoCurrencyCode,
    expandable: 'expandable',
    status: charge.status,
  };
};
